var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { IVR as ActionModal } from '../modals/ivr';
const portTranslator = (node) => {
    const { buttons } = node.payload;
    return Object.keys(buttons).map((key) => ({
        id: uuid(),
        type: 'out',
        label: `Press ${buttons[key].button}`,
        connection: buttons[key].nodeId,
    }));
};
export class IVRNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        return (_jsx(FlowNode, { color: IVRNode.color, icon: IVRNode.icon, label: IVRNode.label, text: _jsx(AnnounceFromPayload, { node: this.props.node, extraData: this.props.extraData }), onEdit: this.triggerEdit }));
    }
}
IVRNode.icon = 'th';
IVRNode.label = 'IVR';
IVRNode.helpText = 'Give incoming callers options to choose from using their dial pad before talking to an agent.';
IVRNode.color = flowNodeColor.purple;
IVRNode.translatePayload = formatPortsHelper(portTranslator);
IVRNode.ActionModal = ActionModal;
IVRNode.actionTrigger = { type: FlowNodeTypes.IVR_MENU };
IVRNode.updateConnection = (node, port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    const { buttons } = payload;
    let oldNodeId;
    Object.keys(buttons).find((key) => {
        if (buttons[key].nodeId === port.connection) {
            oldNodeId = buttons[key].nodeId;
            payload.buttons[key].nodeId = newConnection;
            return true;
        }
        return false;
    });
    if (oldNodeId === node.payload.default_node_id) {
        payload.default_node_id = newConnection;
    }
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], IVRNode.prototype, "triggerEdit", null);
